@if (titleText) {
    <header class="racing-panel-header">
        <span class="racing-panel-title" data-crlat="raceGrid.meeting.name" [innerHTML]="titleText"></span>
        <ng-content select="[header]"></ng-content>
    </header>
}
<div class="scroll-panel" data-crlat="eventTimePanel.tabs">
    <div class="scroll-container" scrollable-racing [rescrollOnChange]="events?.length ? eventId : null">
        <ul class="scroll-inner">
            @for (event of events; track '$' + $index + '$' + event.id) {
                <li
                    [ngClass]="{ 'active': eventId === event.id, 'race-on': !event.isResulted && (!event.isStarted || event.isLiveNowEvent) }"
                    [attr.data-eventid]="event.id"
                    data-crlat="raceGrid.event">
                    <a class="tab" linkHref [link]="formEdpUrl(event)" (click)="goToEvent(event, $event)" ClickLinkDirective data-crlat="tab">
                        <span
                            class="racing-time"
                            [textContent]="event.localTime"
                            data-crlat="raceGrid.raceTime"
                            [ngClass]="{ 'text-bold': isLpAvailable(event) }">
                        </span>
                        @if (
                            isShowName &&
                            !(event.id.toString() === removeEventnameId) &&
                            !event.displayName &&
                            !(event.isResulted || event.isStarted || event.isLiveNowEvent)
                        ) {
                            <span
                                class="racing-name"
                                [textContent]="event.name | slice: 0 : 4"
                                data-crlat="raceGrid.raceName"
                                [ngClass]="{ 'text-bold': isLpAvailable(event) || ladsTabNav }"></span>
                        }
                        @if (isShowName && event.displayName) {
                            <span
                                class="racing-name display-name"
                                [ngClass]="{ 'text-bold': isLpAvailable(event) }"
                                [textContent]="event.displayName"
                                data-crlat="raceGrid.raceName"></span>
                        }

                        <lazy-component
                            moduleUri="@lazy-modules-module/racingStatus/racing-status.module#RacingStatusModule"
                            [inputs]="{
                                event: event,
                                eventEntity: eventEntity,
                                isEventSelected: eventId === event.id,
                                isHrEdp: isHrEdp === false ? false : true,
                                liveServeSubscription: liveServeSubscription,
                            }"
                            [outputs]="['removeEventNameEmitter', 'eventStatusUpdate']"
                            (event)="handleOutput($event)">
                        </lazy-component>
                    </a>
                </li>
            }
            <ng-content select="[list]"></ng-content>
        </ul>
    </div>
</div>
